import React from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import PerformanceHistory from './PerformanceHistory';
import RatingMetrics from './RatingMetrics';

const DrivePerformanceChart = () => {
  const { companyId, driverId } = useParams();

  return (
    <Container>
      <PerformanceHistory
        baseUrl={`ba/v1/drivers/${driverId}/performance-insights?companyId=${companyId}&isLookup=false`}
      />
      <RatingMetrics
        baseUrl={`ba/v1/drivers/${driverId}/rating-metrics?companyId=${companyId}&isLookup=false`}
      />
    </Container>
  );
};

export default DrivePerformanceChart;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
